import { type ReactElement } from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';

export type BodyBackgroundColorProps = {
  bodyColor: string;
  /** When set, animates `background-color` changes (e.g. auth → app shell). */
  transitionMs?: number;
};

/**
 * Overrides `document.body` background for routes that need a different canvas than
 * the default app body styles (`theme.background.default.backend`). Used by patient
 * check-in, waiting room, in-call, and {@link AppBodyBackground}.
 */
export const BodyBackgroundColor = ({
  bodyColor,
  transitionMs,
}: BodyBackgroundColorProps): ReactElement => (
  <GlobalStyles
    styles={{
      body: {
        backgroundColor: bodyColor,
        ...(transitionMs !== undefined && {
          transition: `background-color ${transitionMs}ms ease-out`,
        }),
      },
    }}
  />
);
